import React from 'react'

import styles from './index.scss'

function NoHeaderItem() {
  return <div className={styles.item}>&nbsp;</div>
}

export default NoHeaderItem
